import { Text } from '~/components/ui/Text';
import { IHudTaskProgress } from '~/shared';
import { LineDecor } from '../LineDecor';
import { questTypesStyles } from './Quest.model';
import {
	StyledContainer,
	StyledQuestType,
	StyledQuestTypeIcon,
} from './Quest.styled';

const Quest: React.FC<IHudTaskProgress> = ({
	type,
	text,
	currentCount,
	targetCount,
}: IHudTaskProgress) => {
	return (
		<StyledContainer>
			<StyledQuestType
				$backgroundColor={questTypesStyles[type].backgroundColor}
				$textColor={questTypesStyles[type].textColor}
			>
				<StyledQuestTypeIcon src={questTypesStyles[type].icon} />
				<LineDecor $height={20} />
				{questTypesStyles[type].text}
			</StyledQuestType>
			<Text
				style={{
					fontSize: '16px',
					fontWeight: 500,
					textAlign: 'right',
					color: '#ffffff',
					textShadow: '1px 1px 0px #000000',
				}}
			>
				{text}
			</Text>
			{targetCount > 1 && (
				<Text
					style={{
						fontSize: '14px',
						fontWeight: 500,
						textAlign: 'right',
						color: '#e0e0e0',
						textShadow: '1px 1px 0px #000000',
					}}
				>
					<span style={{ fontWeight: 700, color: '#FABE2C' }}>
						{currentCount?.toLocaleString('ru-RU')}
					</span>
					&nbsp;из&nbsp;
					{targetCount?.toLocaleString('ru-RU')}
				</Text>
			)}
		</StyledContainer>
	);
};

export { Quest };
